module.exports = __webpack_public_path__ + "img/10846.f401ae7d.jpg";